<script lang="ts">
	import comingSoon from "@assets/images/coming-soon-black.png?webp&h=250&imagetools";
	import heroImageXs from "@assets/images/fathers-family-hero.jpg?webp&h=1000&quality=95&imagetools";
	import heroImageSm from "@assets/images/fathers-family-hero.jpg?webp&h=1300&quality=95&imagetools";
	import heroImageLg from "@assets/images/fathers-family-hero.jpg?webp&h=1600&imagetools";
	import heroImageXl from "@assets/images/fathers-family-hero.jpg?webp&h=1900&imagetools";
	import heroImage2xl from "@assets/images/fathers-family-hero.jpg?webp&h=1920&imagetools";
	import heroImage3xl from "@assets/images/fathers-family-hero.jpg?webp&imagetools";
	import fathersFamilyLogo from "@assets/images/fathers-family-written.png?webp&w=642&&imagetools";
	import holdingCups from "@assets/images/holding-cups.jpg?webp&w=580&imagetools";
	import Heading from "@components/common/Heading.svelte";
	import Media from "@components/common/Media.svelte";
	import Layout from "@components/layout/Layout.svelte";
	import SubscriptionAboutSection from "@components/membership/MembershipAboutSection.svelte";
	import SubscriptionBenefitsSection from "@components/membership/MembershipBenefitSection.svelte";
	import FaqSection from "@components/sections/FaqSection.svelte";
	import ImageSection from "@components/sections/ImageSection.svelte";
	import LongTermSubscriptionSection from "@components/sections/LongTermSubscriptionSection.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import translations from "./MembershipPage.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
</script>

<Layout transparentHeader>
	<ImageSection
		class="min-h-[45rem] xl:!h-[calc(100vh-9rem)] pointer-events-none relative"
		sources={{
			default: heroImageXs,
			">lg": heroImageLg,
			">sm": heroImageSm,
			">xl": heroImageXl,
			">2xl": heroImage2xl,
			">3xl": heroImage3xl,
		}}
		media="object-[45%_35%]"
		darkOverlay={false}
	>
		{#snippet heading()}
			<Heading
				level={1}
				text={translate("heroTitle")}
				class="absolute top-44 left-1/2 -translate-x-1/2 w-[min(90vw,40rem)]"
			>
				<Media
					width={640}
					height={442}
					sourcesets={{}}
					source={{ type: "image/webp", src: fathersFamilyLogo }}
					alt=""
				/>
			</Heading>
		{/snippet}
	</ImageSection>
	<SubscriptionBenefitsSection />
	<SubscriptionAboutSection />
	<FaqSection />
	<LongTermSubscriptionSection />
	<section
		class="full-width grid-container bg-fcrbeige py-10 sm:py-15 md:py-20 lg:py-25 xl:py-30 2xl:py-40 gap-y-10 sm:gap-y-15 md:gap-y-20 lg:gap-y-25 xl:gap-y-30 2xl:gap-y-40"
	>
		<div class="container-8 xl:container-start-7 xl:container-end-12">
			<div class="flex flex-col w-full xl:w-fit items-center">
				<Heading
					level={2}
					text={translate("faqTitle")}
					class="font-antipol font-medium text-8/tighter text-fcrdarkgray text-center mb-8"
				/>
				<Media
					source={{ src: comingSoon, type: "image/webp" }}
					width={443}
					height={250}
					sourcesets={{}}
					class="mx-auto xl:mx-0"
					alt=""
				/>
			</div>
		</div>
		<div class="xl:order-first xl:container-start-1 xl:container-end-6 flex items-center justify-center xl:h-full">
			<Media source={{ src: holdingCups, type: "image/webp" }} width={580} height={386} sourcesets={{}} alt="" />
		</div>
	</section>
</Layout>
